// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAccountGetUsersGetUsersContactInfoResponseModel {
    static getAttributeTypeMap() {
        return ScriptsAccountGetUsersGetUsersContactInfoResponseModel.attributeTypeMap;
    }
}
ScriptsAccountGetUsersGetUsersContactInfoResponseModel.discriminator = undefined;
ScriptsAccountGetUsersGetUsersContactInfoResponseModel.additionalProperties = false;
ScriptsAccountGetUsersGetUsersContactInfoResponseModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=scriptsAccountGetUsersGetUsersContactInfoResponseModel.js.map